// extracted by mini-css-extract-plugin
export var askAiIcon = "_m2-9";
export var container = "_m2-0";
export var groupSeparator = "_m2-a";
export var highlight = "_m2-4";
export var resultIcon = "_m2-5";
export var resultItem = "_m2-7";
export var resultSubtitle = "_m2-3";
export var resultTitle = "_m2-2";
export var resultsList = "_m2-1";
export var searchGroup = "_m2-6";
export var selected = "_m2-8";